import * as yup from "yup";

export const ProposalPrivateRoomSchema = yup.object().shape({
  deal_url: yup.string().optional().nullable(),
  briefing: yup.string().optional(),
  extra_value: yup
    .number()
    .optional()
    .nullable()
    .transform((value, originalValue) => (originalValue === "" ? null : value))
    .typeError("O valor deve ser um número")
    .min(0, "O valor extra deve ser positivo"),
});
